export default __webpack_public_path__ + "static/278362009_408432977311758_6116022313969556397_n-76ddfc4f9e651c4aa39a4e74d6f6e94f.jpeg";